import { projectAuthHeaders } from '../projectAuth';
import { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { FiFileText } from 'react-icons/fi';
import { BACKEND_MAIN_URL } from '../config';
import WorkspaceDialog from './WorkspaceDialog';

// The project request uses the same verified session as the rest of the workspace.
export default function NewProjectModal({ onClose, onCreated }) {
  const { t } = useTranslation('workspace');
  const [name, setName] = useState('');
  const [instructions, setInstructions] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);
  async function submit(event) {
    event.preventDefault();
    if (!name.trim() || saving) return;
    setSaving(true); setError(false);
    try {
      const { data } = await axios.post(`${BACKEND_MAIN_URL}/api/projects`, { name: name.trim(), instructions }, { headers: projectAuthHeaders() });
      onCreated?.(data);
    } catch { setError(true); } finally { setSaving(false); }
  }
  return <WorkspaceDialog title={t('newProject')} onClose={() => { if (!saving) onClose(); }}>
    <form className="ws-form" onSubmit={submit}>
      <p className="ws-muted">{t('createHint')}</p>
      <label className="ws-field">{t('name')}<input autoFocus required maxLength={100} value={name} onChange={(event) => setName(event.target.value)} placeholder={t('namePlaceholder')} /></label>
      <label className="ws-field"><span>{t('context')} <small>{t('optional')}</small></span><textarea rows={5} maxLength={2000} value={instructions} onChange={(event) => setInstructions(event.target.value)} placeholder={t('contextPlaceholder')} /><small>{t('contextHint')}</small></label>
      <p className="ws-note"><FiFileText />{t('filesLater')}</p>
      {error && <p className="ws-error" role="alert">{t('saveError')}</p>}
      <div className="ws-form-actions"><button type="button" className="ws-secondary" disabled={saving} onClick={onClose}>{t('cancel')}</button><button type="submit" className="ws-primary" disabled={saving || !name.trim()}>{t(saving ? 'creating' : 'create')}</button></div>
    </form>
  </WorkspaceDialog>;
}
